import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import styles from './Container.module.sass'

const Container = ({
  align, children, maxWidth, padding,
}) => (
  <div className={cn(styles.container, styles[maxWidth], styles[align], styles[`padding-${padding}`])}>
    {children}
  </div>
)

Container.defaultProps = {
  align: 'center',
  maxWidth: 'xl',
  padding: 0,
}

Container.propTypes = {
  align: PropTypes.oneOf([
    'center',
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  maxWidth: PropTypes.oneOf([
    'sm',
    'md',
    'lg',
    'xl',
  ]),
  padding: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
}

export default Container
